import React, {useState, useEffect} from "react";
import { Stack } from "react-bootstrap";
import { Link } from "react-router-dom";
import HeaderMiniso from "../Home/HeaderMiniso/HeaderMiniso";
import MyFooter from "../Home/MyFooter/MyFooter";
import logoFace from "./facebookLogo1.png";
import logoGoogle from "./googleLogo1.png";
import logoMinisoLove from "./minisoLoveLogoLealtad.png";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import useUser from "../../hooks/useUser";
import DataClient from "../Home/MyForm/DataClient/DataClient";
import { getFindClientAptosByEmail, getDataCLMFClientVtexByEmail } from "../../api/apiNewUser";
import './Lealtad.css';
import { useLogin } from 'react-facebook';
import {LoginSocialFacebook} from 'reactjs-social-login';
import {FacebookLoginButton} from 'react-social-login-buttons';
import { id_face } from "../../assets/constantes";
import { img1CarruselDesktop,img1CarruselMobile } from "../../assets/ImgLinks";
import WelcomeMinisoLover from "../Home/WelcomeMinisoLover";
import UserExists from "../Home/MyForm/UserExists";
import '../../assets/animaciones.css';


/*
email:"pokeramon.bene@gmail.com"
email_verified:true
family_name:"Ocampo"
given_name:"Ramon"
locale:"es-419"
name:"Ramon Ocampo"
picture:"https://lh3.googleusercontent.com/a/AEdFTp4EwXYXPXDYDEh1OsHcSA8Q1wcbp83O67oZrAVC6Q=s96-c"
sub:"115254643204971193548"
*/

const Lealtad = () => {

  const [myUserInfo, setMyUserInfo] = useState({});
  const [isLogged, setIsLogged] = useState(false);
  const [isFounded, setIsFounded] = useState(false);
  const [dataUser, setDataUser, dataAdmin,setDataAdmin,initialDataUser] = useUser();
  const { login, status, isLoading, error} = useLogin();
  const [userExist, setUserExist] = useState(false);



  useEffect(()=>{
    if(dataUser.cancelRetraying===true){
      setDataUser({...initialDataUser})
      
    }
  },[dataUser.cancelRetraying])

  useEffect(() => {
    if(dataUser.dataID?.idAptos && dataUser.dataID?.idCL){
      console.log('(lealtad) Usuario ya existe en Aptos y Vtex:...')
      setUserExist(true);
    }else{
      setUserExist(false);
    }
  
    
  }, [dataUser.dataID?.idAptos && dataUser.dataID?.idCL])
  

  useEffect(() => {

    if(dataUser.pageReload) setIsLogged(false);
    if(myUserInfo){

      //Cuando entra con Google
      if (myUserInfo.email_verified && !isFounded){
        setDataUser({
          ...dataUser,
          email: myUserInfo.email,
          nameUser: myUserInfo.given_name,
          paterno: myUserInfo.family_name
        })
        setIsLogged(true);
        console.log('Usuario verificado por Google:..');
        buscarUsuario(myUserInfo.email);
    }

    //Cuando entra con faceBook
    if (myUserInfo.id && !isFounded){
      setDataUser({
        ...dataUser,
        email: myUserInfo.email,
        nameUser: myUserInfo.name.split(' ')[0],
        paterno: myUserInfo.name.split(' ')[1]
      })
      setIsLogged(true);
      console.log('Usuario verificado por Facebook:..');
      buscarUsuario(myUserInfo.email);
    }
    } 
    //console.log('Se supone que esta logeado:..');
  
    return 
  }, [myUserInfo,dataUser.pageReload])

  const recuperaDataUser = async (userID,accesToken)=>{
    try {
      const dataUser = await axios.get(`https://graph.facebook.com/${userID}?fields=id,name,email,picture&access_token=${accesToken}`);
      console.log('dataUser:..',dataUser);
      return dataUser.data
    } catch (error) {
      console.log(error);
    }
  }
  

  /*scope: "email, public_profile",
        return_scopes: true,*/
        
  const handleLogin = async ()=>{
    handleLogout();
    try {
      const response = await login({
        scope: "email, public_profile",
        return_scopes: true,
      });

      console.log(response);
      if (response.status==='connected'){
        console.log("response:..", response);
        const accesToken= response.authResponse?.accessToken;
        const userID= response.authResponse?.userID;
        const dataUserProfile = await recuperaDataUser(userID,accesToken);
        console.log('dataUserProfile:..',dataUserProfile);
        setMyUserInfo(dataUserProfile);
      }
    } catch (error) {
      console.log(error.message);
    }
  }
  
  const buscarUsuario = async(email)=>{
    try {
      const busquedaAptos = await getFindClientAptosByEmail(email);
      console.log('busquedaAptos:..',busquedaAptos);
      const idAptos = busquedaAptos.data.dataResAptos;
      console.log('idAptos:..', idAptos);
      const busquedaVtex = await getDataCLMFClientVtexByEmail(email);
      console.log('busquedaVetex:..',busquedaVtex);
      const idCLVtex = busquedaVtex.data.dataCL[0]?.id;
      console.log('idCLVtex:..',idCLVtex);
      if (idAptos&&idCLVtex){
        console.log('Usuario ya registrado:..');
        setUserExist(true);
        setIsFounded(true);
        setIsLogged(false);
        setTimeout(() => {
          setUserExist(false);
        }, 5000);
      } else{
        console.log('Usuario puede continuar con el registro:..');
        setUserExist(false);
      }
      return
    } catch (error) {
      console.log('error al buscar usuario:..',error)
      return error
    }
  }

  const handleLogout = ()=>{
    window.FB.logout((response) => {
      //setIsConnected(false);
      console.log(response);
      // user is now logged out
    });
  }

  const loginGoogle = useGoogleLogin({
    
    onSuccess: async (tokenResponse) => {
      console.log(tokenResponse);
      
      // fetching userinfo can be done on the client or the server
      setIsFounded(false);
      const userInfo = await axios
        .get("https://www.googleapis.com/oauth2/v3/userinfo", {
          headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
        })
        .then((res) => {
              setMyUserInfo(res.data);
              //console.log('Se supone: Usuario verificado por Google:..');
              
          return res.data
        });

      console.log("UserInfo:..", userInfo);
      //if (userInfo) setMyUserInfo(userInfo);
      

      // flow: 'implicit', // implicit is the defaul
      
    },
  });
  return (
    <div>
      <HeaderMiniso />
      {
        userExist &&
        <UserExists/>
      }
      {!isLogged && !dataUser.pageReload &&
      <Stack
      style={{ fontFamily: "Helvetica" }}
      className="border-bottom mt-4 pb-3 text-center fw-bolder"
    >
      <h3 style={{ fontWeight: "700" }} className="fs-4 ">
        ¡Elige una opción para registrarte en MinisoLove!
      </h3>
      <Link style={{color:'inherit', textDecoration:'none', width:'350px'}} className='d-block ms-auto me-auto' to={'/home'}>
      <h3
        style={{
          border: "3px solid #f7c1bb",
          width: "350px",
          fontWeight: "550",
        }}
        className="my-2 p-2 fs-6 rounded"
      >
        RECIBIR CODIGO A MI CORREO
      </h3>
      </Link>
      <a style={{color:'inherit', textDecoration:'none', width:'350px'}} className='d-block ms-auto me-auto d-none' href="https://www.miniso.com.mx/login">
      <h3
        style={{
          border: "3px solid #f7c1bb",
          width: "350px",
          fontWeight: "550",
        }}
        className="my-2 p-2 fs-6 rounded"
      >
        ENTRAR CON CORREO Y CONTRASEÑA
      </h3>
      </a>
      <h3
        style={{
          border: "3px solid #000",
          width: "350px",
          fontWeight: "550",
          cursor: 'pointer'
        }}
        className="my-2 p-2 fs-6 me-auto ms-auto rounded"
        onClick={loginGoogle}
      >
        <img
          style={{ width: "20px" }}
          className="me-3"
          src={logoGoogle}
          alt="logoGoogle"
        />
        ENTRAR CON GOOGLE
      </h3>
      {/* <h3
        style={{
          border: "3px solid #000",
          width: "350px",
          fontWeight: "550",
          opacity: isLoading? '.5':'1',
          cursor:'pointer'
        }}
        className="my-2 p-2 fs-6 me-auto ms-auto rounded"
        onClick={handleLogin}

      >
        <img
          style={{ width: "25px" }}
          className="me-3"
          src={logoFace}
          alt="logoFace"
        />
        ENTRAR CON FACEBOOK
      </h3> */}
      {/* <LoginSocialFacebook
            appId="229254892779739"
            onResolve={({ provider, data }) => {
              console.log('Provider:..',provider);
              console.log('data:..',data);
              //setProvider(provider)
              //setProfile(data)
            }}
            onReject={(err) => {
              console.log(err)
            }}
          >
            
            <FacebookLoginButton /> 
          </LoginSocialFacebook> */}
      <img
        style={{ width: "100px" }}
        className="d-block me-auto ms-auto creceLogo "
        src={logoMinisoLove}
        alt="logoMinisoLove"
      />
      <h3
        style={{ fontWeight: "700" }}
        className="fs-6 text-danger text-small cambiaColor"
      >
        ¿LISTO PARA EMPEZAR?
      </h3>
      <p style={{ fontSize: "13px" }} className="text-secondary opacity-75">
        AL CREAR UNA CUENTA, ACEPTAS LOS TÉRMINOS Y CONDICIONES Y EL AVISO DE
        PRIVACIDAD DE MINISO, CONSÚLTALOS.
      </p>
    </Stack>
      }
      {isLogged && !isFounded &&!dataUser.pageReload&&!dataUser.succedRegister && <DataClient/>}
      {dataUser.succedRegister&&!dataUser.pageReload &&  (
        <div className="pt-3 pb-5">
          <h1 className="text-danger text-center fs-5 mt-4">
            Bienvenido MinisoLover
          </h1>
          <h4 className="text-secondary fs-6 mt-4 text-center">
            Tu Cupón sera enviado a: {dataUser.email}
          </h4>
          <img
            className="d-none d-lg-block w-100 mt-3"
            src={img1CarruselDesktop}
            alt="img1Carrusel"
          />
          <img
            className="d-block d-lg-none w-100 mt-3"
            src={img1CarruselMobile}
            alt="img1Carrusel"
          />
        </div>
      )}
      {dataUser.pageReload&& <WelcomeMinisoLover/>}
      <MyFooter /> 
    </div>
  );
};

export default Lealtad;
